/**
 * Section constants for Hospitalisation v2. Cause is ICD-picked (frontend
 * uses IcdAutocomplete from chiefComplaints); procedures come from the
 * federated /procedure-catalog on api-hospitalisation-v2-service. This file
 * holds the status enum + band lookups used by the table chip and the modal.
 */

/**
 * Status bands (Hospitalised / Discharged). `key` matches the backend enum.
 * Hospitalised is amber (ongoing / attention), Discharged is green (closed).
 */
export const HOSP_STATUS = [
  // Colours off the v3 board's own render (3073:6900).
  { key: "hospitalised", label: "Hospitalised", bg: "#fdead7", fg: "#f97f0f", dot: "#f97f0f" },
  { key: "discharged", label: "Discharged", bg: "#cff8e5", fg: "#065f46", dot: "#065f46" },
];

export const hospStatusBand = (key) =>
  HOSP_STATUS.find((s) => s.key === key) || HOSP_STATUS[0];
